import React, { ReactElement, useEffect, useState } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'

import { Spacing } from '../../style'

import CheckboxSquare from './square'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  square: {
    marginLeft: Spacing.XS,
  },
  squareFirst: {
    marginLeft: 0,
  },
})

export interface Option<T = string> {
  value: T
  title?: string | ReactElement
}

export interface Props<T> extends ViewProps {
  value?: T[]
  items?: Option<T>[]
  onChange?: (value: T[]) => void
  error?: boolean
  disabled?: boolean
  round?: boolean
  optionStyle?: StyleProp<ViewStyle>
}
const CheckboxGroup = (props: Props<any>) => {
  const { value = [], items, onChange, error, disabled, round, style, optionStyle, ...otherProps } = props

  const [selected, setSelected] = useState<Option[]>(items?.filter((opt) => value.indexOf(opt.value) >= 0) || [])

  useEffect(() => {
    setSelected(items?.filter((opt) => value.indexOf(opt.value) >= 0) || [])
  }, [props.value])

  const select = (option: Option) => () => {
    const newSelected = [...selected]
    const index = newSelected.findIndex((opt) => opt.value === option.value)
    if (index >= 0) {
      newSelected.splice(index, 1)
    } else {
      newSelected.push(option)
    }
    setSelected(newSelected)
    onChange?.(newSelected.map((opt) => opt.value))
  }
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {items?.map((groupOption, index) => (
        <CheckboxSquare
          key={groupOption?.value}
          style={[index === 0 ? styles.squareFirst : styles.square, optionStyle]}
          title={groupOption.title || groupOption.value}
          selected={!!selected.find((opt) => opt.value === groupOption.value)}
          onPress={select(groupOption)}
          round={round}
          error={!!error}
          disabled={disabled}
        />
      ))}
    </View>
  )
}

export default CheckboxGroup
